export default "__VITE_ASSET__D8Fs_ENa__"